export enum AnalyticsEvents {
  Email = 'signin_and_signup_email_focused',
  PasswordLogin = 'signin_and_signup_password_login_focused',
  PasswordSignUp = 'signin_and_signup_password_signup_focused',
  FirstName = 'signin_and_signup_first_name_focused',
  LastName = 'signin_and_signup_last_name_focused',
  Phone = 'signin_and_signup_phone_focused',
  ForgotPassword = 'signin_and_signup_forgot_password_clicked',
  ContinueClick = 'signin_and_signup_continue_clicked',
  LoginClick = 'signin_and_signup_login_clicked',
  SignupClick = 'signin_and_signup_signup_clicked',
  MfaRequested = 'signin_and_signup_mfa_requested',
  MfaTriggered = 'signin_and_signup_mfa_flow_triggered',
  LoginFlowTriggered = 'signin_and_signup_login_flow_triggered',
  SignupFlowTriggered = 'signin_and_signup_signup_flow_triggered',
  Landed = 'signin_and_signup_landed',
}

export type EmailChangeEvent = { newValue: string; validate?: boolean };
